import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Entity } from "@common/types/entity";
import type { ButtonProps } from "@design-system/Button/Button";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { getGustoConnectionForEntity } from "@lib/gusto";
import { useSyncGustoConnectionMutation } from "@mutations/gustoConnection";

interface Props {
    entity: Entity;
    children: React.ReactNode;
    variant?: Extract<ButtonProps["variant"], "primary" | "secondary">;
    size?: Extract<ButtonProps["size"], "sm" | "md" | "lg" | "xl">;
    className?: string;
    disabled?: boolean;
}
export const SyncGustoConnection: React.FC<Props> = ({
    entity,
    children,
    variant = "primary",
    size = "md",
    ...btnProps
}) => {
    const { data: connection } = useQuery({
        queryKey: ["entityConnection", entity.id],
        queryFn: () => getGustoConnectionForEntity(entity),
    });

    const syncPayrolls = useSyncGustoConnectionMutation(entity);

    if (!connection) {
        return null;
    }
    return (
        <ButtonWithLoader
            variant={variant}
            size={size}
            onClick={() => syncPayrolls.mutate(connection)}
            loading={syncPayrolls.isPending}
            {...btnProps}
        >
            {children}
        </ButtonWithLoader>
    );
};
